import axios from '../util/axios'
import { MyUtil } from '../util/MyUtil'

class ShopAPI{
  // 加载客户购物车
  loadCart(params = {}) {
    return axios({
      url: '/front/shoppingCart/load',
      method: 'get',
      data: params
    })
  }

  // 查询产品配额
  loadQuota(params = {}) {
    return axios({
      url: 'front/product/selectProductQuotaFromSolr',
      method: 'get',
      data: params
    })
  }

  /**保存客户购物车*/
  refreshCart(params = {}) {
    return axios({
      url: '/front/shoppingCart/refresh',
      method: 'post',
      data: params
    })
  }

  // 通过客户ID从solr获取到当前省办下的促销列表数据
  getPromotions(params = {}) {
    return axios({
      url: '/front/product/selectPromotionsByClientIdFromSolr',
      method: 'get',
      data: params
    })
  }

  // 查询父产品系列/子产品系列分类
  getProductCatalog(params = {}) {
    return axios({
      url: '/front/product/getProductCatalog',
      method: 'get',
      data: params
    })
  }

  // 通过客户ID从solr获取到当前省办下的产品数据
  getProducts(params = {}) {
    return axios({
      url: '/front/product/selectProductsByClientIdFromSolr',
      method: 'get',
      data: params
    })
  }

  // 查询需满多少金额才可下单
  getLeastSum(params = {}) {
    return axios({
      url: '/front/systemParameters/get',
      method: 'post',
      data: params
    })
  }

  // 生成结算预览
  paymentPreview(params = {}) {
    return axios({
      url: '/front/shoppingCart/paymentPreview',
      method: 'post',
      data: params
    })
  }

  // 提交订单
  cartSubmit(params = {}) {
    return axios({
      url: '/front/shoppingCart/submit',
      method: 'post',
      data: params
    })
  }

  // 订单支付
  cartPay(params = {}) {
    return axios({
      url: '/front/shoppingCart/pay',
      method: 'post',
      data: params
    })
  }

  // 退单
  orderRefund(params = {}) {
    return axios({
      url: 'front/order/orderRefund',
      method: 'post',
      data: params
    })
  }

  // 获取客户的指定赠送产品列表
  getClientGiftProducts(params = {}) {
    return axios({
      url: 'front/shoppingCart/getClientGiftProducts',
      method: 'get',
      data: params
    })
  }

  // 检查我的下单计划
  checkOrderPlan(params = {}) {
    return axios({
      url: 'front/order/order/checkOrderPlan',
      method: 'post',
      data: params
    })
  }

  // 查询客户是否有临时单
  getTemporaryOrder(params = {}) {
    return axios({
      url: 'front/shoppingCart/getTemporaryOrder',
      method: 'get',
      data: params
    })
  }

  // 订单预览页取消购买
  cancelTemporaryOrder(params) {
    return axios({
      url: 'front/shoppingCart/cancelTemporaryOrder?orderNo=' + params,
      method: 'post',
      data: null
    })
  }

  // 订单预览页确认购买
  confirmTemporaryOrder(params) {
    return axios({
      url: 'front/shoppingCart/confirmTemporaryOrder?orderNo=' + params,
      method: 'post',
      data: null
    })
  }

  // 通过客户ID从solr获取到必定的促销或产品列表数据
  selectMustPromotionsOrProducts(params = {}) {
    return axios({
      url: 'front/product/selectMustPromotionsOrProducts',
      method: 'get',
      data: params
    })
  }

  // 一键将已取消订单恢复回购物车
  restoreFromOrder(params) {
    return axios({
      url: 'front/shoppingCart/restoreFromOrder?orderNo=' + params,
      method: 'post',
      data: null
    })
  }

  // 检查产品是否下架和缺货
  checkProductDownAndLack(params = {}) {
    return axios({
      url: 'front/product/checkProductDownAndLack',
      method: 'post',
      data: params
    })
  }

  // 检查促销
  checkPromotions(params) {
    return axios({
      url: 'front/promotion/checkPromotions',
      method: 'post',
      data: params
    })
  }

  // 订单合并支付
  mergePay(params = {}) {
    return axios({
      url: 'front/shoppingCart/mergePay',
      method: 'get',
      data: params
    })
  }

  // 订单合并支付预览
  mergePayPreview(params = {}) {
    return axios({
      url: 'front/shoppingCart/mergePayPreview',
      method: 'get',
      data: params
    })
  }

  // 批量客户订单合并支付预览
  multiMergePayPreview(params) {
    return axios({
      url: 'front/shoppingCart/multiMergePayPreview',
      method: 'post',
      data: params
    })
  }

  // 获取折扣差确认信息
  getDiscountConfirm(params) {
    return axios({
      url: 'manage-pub/manage-pub/discountConfirm/getMyconfirm',
      method: 'get',
      data: params
    })
  }

  // 获取折扣差确认信息
  saveDiscountConfirm(params) {
    return axios({
      url: 'manage-pub/manage-pub/discountConfirm/saveConfirm',
      method: 'get',
      data: params
    })
  }

}


export {
  ShopAPI
}


// WEBPACK FOOTER //
// ./src/api/shop.js